<div class="quotes-pdf-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="text-purple-manax text-capitalize title-modal">
          Presupuesto #{{document?.number}}
        </span>
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row">
    <div class="col-12">
      <!--<div id="pdf-content">Cargando...</div>*/-->
      <ngx-extended-pdf-viewer
        [src]="src"
        [height]="'auto'"
        [filenameForDownload]="fileNameDownload"
      >
      </ngx-extended-pdf-viewer>
    </div>
  </div>
</div>